<template lang="pug">
.activity-inner
  Sidebar
  .activity-inner__content
    transition(name="slide-fade" mode="out-in")
      router-view


</template>

<script>
import Sidebar from '@/components/Sidebar.vue'

export default {
  components: {
    Sidebar,
  },
}
</script>

<style lang="scss">
.activity-inner{
  display: flex;
  flex-grow: 1;
  &__content{
    flex-grow: 1;
    padding: 40px 30px;
    overflow-x: hidden;
  }
}
</style>